import React, { useState } from 'react';
import { Phone, Mail, MapPin, Send, CheckCircle } from 'lucide-react';
import { SITE } from '../mock/mock';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => setSent(false), 5000);
  };

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div>
      <div className="ps-blue-bg text-white">
        <div className="max-w-7xl mx-auto px-6 py-16 text-center">
          <h1 className="font-anton text-5xl sm:text-6xl">CONTACT US</h1>
          <p className="text-white/70 mt-4 max-w-xl mx-auto">Questions about our products or wholesale pricing? We'd love to hear from you.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12">
        {/* info */}
        <div>
          <h2 className="font-anton text-3xl ps-blue-text mb-6">GET IN TOUCH</h2>
          <p className="text-gray-600 mb-8 leading-relaxed">Reach out to our friendly customer service team for product info, order support, or wholesale &amp; custom logo inquiries.</p>
          <div className="space-y-5">
            <a href={`tel:${SITE.phoneLink}`} className="flex items-center gap-4 group">
              <div className="w-12 h-12 rounded-full ps-yellow-bg flex items-center justify-center group-hover:scale-110 transition-transform"><Phone size={20} className="text-[#1a1ad6]" /></div>
              <div>
                <p className="font-oswald uppercase text-xs text-gray-400">Call Us</p>
                <p className="font-oswald text-lg text-gray-900 group-hover:text-[#1a1ad6]">{SITE.phone}</p>
              </div>
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-4 group">
              <div className="w-12 h-12 rounded-full ps-yellow-bg flex items-center justify-center group-hover:scale-110 transition-transform"><Mail size={20} className="text-[#1a1ad6]" /></div>
              <div>
                <p className="font-oswald uppercase text-xs text-gray-400">Email Us</p>
                <p className="font-oswald text-lg text-gray-900 group-hover:text-[#1a1ad6]">{SITE.email}</p>
              </div>
            </a>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full ps-yellow-bg flex items-center justify-center"><MapPin size={20} className="text-[#1a1ad6]" /></div>
              <div>
                <p className="font-oswald uppercase text-xs text-gray-400">Visit</p>
                <p className="font-oswald text-lg text-gray-900">{SITE.domain}</p>
              </div>
            </div>
          </div>
          <div className="mt-10 rounded-2xl overflow-hidden shadow-md">
            <img src="https://images.unsplash.com/photo-1589924749359-9697080c3577?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxkb2clMjB0b3lzfGVufDB8fHx8MTc4Nzg2NjAxM3ww&ixlib=rb-4.1.0&q=85" alt="Pets" className="w-full h-52 object-cover" />
          </div>
        </div>

        {/* form */}
        <div className="bg-gray-50 rounded-3xl p-8 shadow-sm">
          {sent && (
            <div className="mb-6 flex items-center gap-3 bg-green-50 text-green-700 px-4 py-3 rounded-xl fade-up">
              <CheckCircle size={20} /> <span>Thanks! Your message has been sent (demo).</span>
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label className="font-oswald uppercase text-xs text-gray-500 mb-1.5 block">Name</label>
                <input required value={form.name} onChange={update('name')} className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white outline-none focus:border-[#1a1ad6] transition-colors" placeholder="Your name" />
              </div>
              <div>
                <label className="font-oswald uppercase text-xs text-gray-500 mb-1.5 block">Email</label>
                <input required type="email" value={form.email} onChange={update('email')} className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white outline-none focus:border-[#1a1ad6] transition-colors" placeholder="you@email.com" />
              </div>
            </div>
            <div>
              <label className="font-oswald uppercase text-xs text-gray-500 mb-1.5 block">Subject</label>
              <input required value={form.subject} onChange={update('subject')} className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white outline-none focus:border-[#1a1ad6] transition-colors" placeholder="How can we help?" />
            </div>
            <div>
              <label className="font-oswald uppercase text-xs text-gray-500 mb-1.5 block">Message</label>
              <textarea required rows={5} value={form.message} onChange={update('message')} className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white outline-none focus:border-[#1a1ad6] transition-colors resize-none" placeholder="Write your message..." />
            </div>
            <button type="submit" className="w-full ps-blue-bg text-white py-3.5 rounded-xl font-oswald uppercase tracking-wide text-lg btn-press hover:bg-[#0f0fa0] flex items-center justify-center gap-2">
              <Send size={18} /> Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
